import actionTypePrefixes from "./actionTypePrefixes"

/* eslint-disable import/prefer-default-export */
// Remove eslint comment above if we add more actions (as expected)

export function setReportType(reportType) {
  return {
    type: `${actionTypePrefixes.ReportSelection}SET_REPORT_TYPE`,
    reportType,
  }
}

export function setReviewId(reviewId) {
  return {
    type: `${actionTypePrefixes.ReportSelection}SET_REVIEW_ID`,
    reviewId,
  }
}

export function setAppraisalLevelId(appraisalLevelId) {
  return {
    type: `${actionTypePrefixes.ReportSelection}SET_APPRAISAL_LEVEL_ID`,
    appraisalLevelId,
  }
}

export function setIncludeLeavers(includeLeavers) {
  return {
    type: `${actionTypePrefixes.ReportSelection}SET_INCLUDE_LEAVERS`,
    includeLeavers,
  }
}

export function setIncludePerformance(includePerformance) {
  return {
    type: `${actionTypePrefixes.ReportSelection}SET_INCLUDE_PERFORMANCE`,
    includePerformance,
  }
}

export function setSelectedQuestions(exportDetails, numberOfSelectedQuestions) {
  return {
    type: `${actionTypePrefixes.ReportSelection}SET_SELECTED_QUESTIONS`,
    exportDetails,
    numberOfSelectedQuestions,
  }
}

export function setLocationsAndEmployees(locations, employees) {
  return {
    type: `${actionTypePrefixes.ReportSelection}SET_LOCATIONS_AND_EMPLOYEES`,
    locations,
    employees,
  }
}
export function setEmployeeDetailOptions(optionsSelected) {
  const employeeDetailOptions = optionsSelected
    .filter((option) => {
      return option.selected === true
    })
    .map((opt) => {
      return opt.value
    })
  return {
    type: `${actionTypePrefixes.ReportSelection}SET_EMPLOYEE_DETAIL_OPTIONS`,
    employeeDetailOptions,
  }
}

export function resetReportSelection() {
  return {
    type: `${actionTypePrefixes.ReportSelection}RESET_REPORT_SELECTION`,
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/reportSelectionActions.js